<template>
  <div class="page">
    <navigation
      :theme="{
        background: '#fff',
        color: '#fff'
      }"
    ></navigation>
    <div class="animation-csy" v-if="['NO_PRE_CREDIT', 'NO_CREDIT','CREDIT_IN_PROGRESS'].includes(this.newPersonStatus)" ></div>
    <div class="result-container" v-else>
      <div class="title"></div>
      <div class="content">
        <div class="content-top">
          您有一个现金红包 <br />
          <template v-if="!['COUPON_USE_OR_EXPIRED','COUPON_BIND'].includes(newPersonStatus)"> {{formatDate(expirationTime)}} 前完成借款有效</template>
        </div>
        <div class="content-detail"><span> {{ amount }} </span><small>元</small></div>
        <div class="button" @click="$router.push(newPersonStatus==='COUPON_USE_OR_EXPIRED'?'/quan/history':'/quan/list')">查看券包</div>
      </div>
    </div>

    <section class="header" :style="`margin-top:${statusBarHeight}px`">
      <img :src="require('@/view/user/images/logo.png')" class="logo" />
      <div class="rule" @click="$router.push('/unauthedNewbie/rule')">
        <img :src="require('./images/icon_guizhe.png')" />活动规则
      </div>
    </section>
    <template v-if="clickStatus !==null">
      <div class="handle-btn" @click="showDialog" v-if="['NO_PRE_CREDIT', 'NO_CREDIT', 'CREDIT_IN_PROGRESS'].includes(this.newPersonStatus)"  :style="`margin-top:${statusBarHeight}px`">
        开始发财
      </div>
      <div class="handle-btn"  v-if="newPersonStatus==='NO_USE_COUPON'" @click="toWithdraw"  :style="`margin-top:${statusBarHeight}px`" >申请提现</div>
    </template>
    <!-- 微信 -->
    <div :class="['wx-container',{join:newPersonStatus==='COUPON_USE_OR_EXPIRED'}]">
      <div class="copy" @click="copy"></div>
    </div>
    <p class="tips">活动最终解释权归天美贷所有</p>
    <!-- 弹窗区域 -->

    <!-- 未授信弹窗 -->
    <nd-dialog
      v-model="creditVisible"
      :footer="false"
      closeBtn
      class="credit-dialog"
    >
      <div class="qq"></div>
      <p>申请授信才能领取现金红包哦！</p>
      <nd-button class="btn" @click="toResult">前往认证</nd-button>
    </nd-dialog>

    <!-- 封禁 -->
    <nd-dialog
      v-model="showDialogLimit"
      :footer="false"
      closeBtn
      class="refused-dialog"
    >
      <h4>抱歉，您当前无法提现</h4>
      <p> 当前处于封禁期，请于 <br>
        {{formatDate(limitData.lockingDay)}}重新发起！</p>
      <nd-button class="btn" @click="toResult">查看详情</nd-button>
    </nd-dialog>


    <!-- 财神动画 -->
    <nd-dialog
      closeBtn
      v-model="csyVisible"
      :footer="false"
      class="csy-dialog"
    >
      <div :class="['csy-animation',{showResult: !showResult}]">
        <div class="rotate-container">
          <i class="hb">1.68元</i>
          <i class="hb">6.68元</i>
          <i class="hb">188元</i>
          <i class="hb">168元</i>
          <i class="hb">128元</i>
        </div>
      </div>
      <div :class="['hb-contaner',{showResult: showResult,fallDown:fallDown}]">
        <div class="light"></div>
        <div class="hb-bg">
          <span>{{amount}}</span><small>元</small>
        </div>
      </div>
      <div class="qb-container" v-if="showResult">
        我的券包
      </div> 
    </nd-dialog>
  </div>
</template>

<script>
import { copyToClipbord, judgeClientSystem } from '@/assets/utils'
import { mapActions, mapState } from 'vuex'
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'

export default {
  name: 'about',
  data () {
    return {
      publicAccount: 'ct_tmd',
      showDialogLimit: false,
      creditVisible: false,
      csyVisible: false,
      showResult: false,
      fallDown: false,
      join: false,
      /**
       * 新人活动处于节点状态
       * NO_PRE_CREDIT 未预授信;
       * NO_CREDIT 未授信; 
       * CREDIT_IN_PROGRESS 授信中；
       * NO_USE_COUPON 红包未使用; 
       * COUPON_BIND 红包未使用，但是关联借据
       * COUPON_USE_OR_EXPIRED 红包使用或者过期
       */
      newPersonStatus: '',
      clickStatus: null,
      amount: '',
      status: '',
      expirationTime: '',
      limitData: {},
      timer: null
    }
  },
  computed: {
    ...mapState({
      statusBarHeight: (state) => state.statusBarHeight 
    })
  },
  watch: {
    csyVisible (val) {
      if (!val) {
        this.reset()
      }
    }
  },
  async mounted () {
    await Promise.all([this.info(), this.getLimit(), this.getAmount()])
    if ((['NO_USE_COUPON', 'COUPON_BIND'].includes(this.newPersonStatus) || ['CREDIT_REFUSED', 'CREDIT_REVIEW'].includes(this.limitData.creditStatus)) && !this.clickStatus) {
      this.csyVisible = true
      const { success } = await this.clickNewPerson()
      if (success) {
        this.getCouponStatus(true)
      }
    }
    this.$bus.$emit('ready')
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    ...mapActions('user', ['newPersonActive', 'couponStatus', 'clickNewPerson', 'getLimitX']),
    async getLimit () {
      const { success, data } = await this.getLimitX({ loanPlatform: 'TMD' })
      if (success) {
        this.limitData = data || {}
      }
    },
    navigateTo (path) {
      if (hasNativeMethod('navigateTo') && !!path.native && judgeClientSystem() !== 'IOS') {
        jsBridge('navigateTo', { path: path.native, exitCurrent: true })
      } else {
        this.$router.push(path.h5)
      }
    },
    auth () {
      if (this.newPersonStatus === 'NO_PRE_CREDIT') {
        this.navigateTo({ h5: '/authentication/id', native: 'ocr' })
      } else {
        this.navigateTo({ h5: '/authentication/base', native: 'basic_info' })
      }
    },
    // 跳两个结果页
    toResult () {
      this.$router.push('/middle/limit')
    },
    toWithdraw () {
      // 授信拒绝 
      if (['CREDIT_REFUSED', 'LOAN_REFUSED'].includes(this.limitData.creditStatus)) {
        this.showDialogLimit = true
        return 
      }
      this.$router.push('/middle/limit')
    },
    async info () {
      const { success, data } = await this.newPersonActive()
      if (success) {
        const { newPersonStatus, clickStatus, couponExpiredTime } = data
        this.newPersonStatus = newPersonStatus
        this.clickStatus = clickStatus
        this.expirationTime = couponExpiredTime
        // 未点击动画 && 红包未使用 
        if (!clickStatus && this.newPersonStatus === 'NO_USE_COUPON') {
          this.showDialog()
        }
      }
    },
    async showDialog () {
      if (['NO_PRE_CREDIT', 'NO_CREDIT'].includes(this.newPersonStatus)) {
        this.creditVisible = true
        return
      }
      if (['CREDIT_IN_PROGRESS'].includes(this.newPersonStatus)) {
        return this.$router.push(`/authentication/result?applyNo=${this.limitData.serialNo}`)
      }
    },
    async getAmount () {
      const { success, data } = await this.couponStatus()
      if (success) {
        const { amount } = data
        this.amount = amount
      }
    },
    async getCouponStatus () {
      const { success, data } = await this.couponStatus()
      if (success) {
        // 状态 PROVIDE_FAIL("发放失败"),PROVIDE_WAIT("等待发放"),PROVIDE_SUCCESS("发放成功")
        const { amount, status } = data
        if (status === 'PROVIDE_WAIT') {
          this.timer = setTimeout(() => {
            this.getCouponStatus()
          }, 5000)
        } else if (status === 'PROVIDE_SUCCESS') {
          this.amount = amount
          this.handleShowResut()
        } else {
          this.reset()
        }
      }
    },
    copy () {
      copyToClipbord(this.publicAccount)
      this.$message('已复制到剪贴板')
    },
    reset () {
      setTimeout(() => {
        this.showResult = false
        this.fallDown = false
        this.info()
      }, 300)
      clearTimeout(window.timer1)
      clearTimeout(window.timer2)
      clearTimeout(window.timer3)
    },
    handleShowResut () {
      window.timer1 = setTimeout(() => {
        this.showResult = true
      }, 3000)
      // 优惠券飞入盒子
      window.timer2 = setTimeout(() => {
        this.fallDown = true
      }, 5000)
      // 关闭dialog
      window.timer3 = setTimeout(() => {
        this.csyVisible = false
      }, 6000)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  background: #f7e0b4;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .header {
    position: absolute;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 20px 40px;
    align-items: center;
    top: 120px;
    & > img {
      width: 70px;
    }
    .rule {
      img {
        width: 32px;
        margin-right: 10px;
      }
      display: flex;
      align-items: center;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
  @keyframes bg {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: 100% 0;
    }
  }
  .handle-btn {
    width: 500px;
    height: 168px;
    background: url(./images/btn_facai.png) no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 1180px;
    left: 50%;
    margin-left: -250px;
    line-height: 168px;
    font-size: 52px;
    font-family: PingFangHK-Medium, PingFangHK;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
  }

  .result-container {
    position: relative;
    width: 750px;
    height: 1170px;
    background: url(./images/img_b.png) no-repeat;
    background-size: 100% 1170px;
    
    .title {
      width: 644px;
      height: 192px;
      background: url(./images/title.png) no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: 143px;
      left: 51px;
    }
    .content-top {
      font-size: 24px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #ffffff;
      position: absolute;
      width: 100%;
      text-align: center;
      top: 460px;
      width: 100%;
    }
    .content-detail {
      text-align: center;
      position: absolute;
      width: 100%;
      text-align: center;
      top: 590px;
      width: 100%;
      span {
        font-size: 100px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: #c01004;
      }
      small {
        font-size: 28px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #c01004;
        margin-left: -20px;
      }
    }

    

    .button {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 739px;
      width: 209px;
      height: 60px;
      border-radius: 30px;
      border: 1px solid #c01004;
      font-size: 28px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #c01004;
      line-height: 60px;
      text-align: center;
    }
  }
  .animation-csy {
    width: 750px;
    height: 1170px;
    position: relative;
    background: url(./images/xinyonghu_hebing_00000.jpg) no-repeat;
    background-size: 100% 100%;

    &::before {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      background: url(./images/animation.jpg) no-repeat;
      background-size: 6000px 1170px;
      animation: bg 0.5s steps(7) infinite;
    }
  }

  .wx-container {
    width: 748px;
    height: 790px;
    background: url(./images/img_songhaoli.png) no-repeat;
    background-size: 100% 100%;
    margin-top: 50px;
    position: relative;
    &.join{
      margin-top: -100px;
    }
    .copy {
      width: 570px;
      height: 88px;
      background: url(./images/img_gongzhonghao.png) no-repeat;
      background-size: 100% 100%;
      position: absolute;
      left: 90px;
      top: 556px;
    }
  }

  .tips {
    padding: 30px 0;
    text-align: center;
    color: #bfa36c;
    font-size: 22px;
  }
}
.csy-dialog {
  /deep/.nd-mask{
    background: rgba(0, 0, 0, 0.9) !important;
  }
  /deep/.nd-dialog-content {
    width: 750px;
    height: 820px;
    .default-content {
      background: none;
      width: 750px;
      height: 820px;
    }
    @keyframes csyRotate {
      to {transform: rotateZ(360deg);}
    }
    @keyframes csyRotate2 {
      to {transform: rotateZ(-360deg);}
    }
    @keyframes light {
      to {opacity: 1;}
    }
    @keyframes showResult {
      0% {
        transform: scale(0);
      }
      100% {
        transform: scale(1);
      }
    }
    @keyframes fallDown {
      0% {
        transform:translateY(0px) scale(1);
      }
      50% {
        transform:translateY(-300px) scale(0.5);
      }
      100% {
        transform:translateY(500px) scale(0);
      }
    }
    .qb-container {
      width: 150px;
      height: 200px;
      background: url(./images/icon_quanbao.png) no-repeat center top;
      background-size: 100px 100px;font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      padding-top: 120px;
      text-align: center;
      position: absolute;
      bottom: 50px;
      left: 50%;
      top: 850px;
      margin-left: -75px;
    }
    .hb-contaner{
      width:750px;
      height:750px;
      position: absolute;
      top:50%;
        margin-top: -400px;
      display: none;
      &.showResult {
        display: block;
        animation: showResult 0.5s  forwards;
      }
      &.fallDown {
        animation: fallDown 1s linear forwards;
      }
      .light{
        width:100%;
        height:100%;
        position: absolute;
        background: url(./images/img_guang.png) no-repeat;
        background-size: 100% 100%;
        animation: light .3s ease-in-out infinite alternate;
        opacity: 0.2;
      }
      .hb-bg{
        width:400px;
        height:473px;
        position: absolute;
        background: url(./images/img_hongbao2.png) no-repeat;
        background-size: 400px 473px;
        left: 50%;
        top:50%;
        transform: translate(-50%,-50%);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        span {
          font-size: 90px;
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          color: #C01004;
        }
        small {
          font-size: 24px;
          font-family: PingFangHK-Medium, PingFangHK;
          font-weight: 500;
          color: #C01004;
          padding-top: 40px;
        }
      }
    }
    .csy-animation{
        width: 750px;
        height: 820px;
        background: url(./images/img_caishen.png) no-repeat;
        background-size: 100% 100%;
        position: relative;
        display: none;
        &.showResult {display: block;}
        .rotate-container{
          width:82px;
          height:105px;
          position: absolute;
          left:50%;top:50%;
          margin-left: -41px;
          margin-top: -70px;
          animation:csyRotate 3s linear  infinite;
        }
        i.hb {
          position: absolute;
          width:82px;
          height:105px;
          background: url(./images/img_hongbao.png) no-repeat;
          background-size: 100% 100%;
          padding-top: 50px;
          font-size: 22px;
          text-align: center;
          color: #f7e0b4;
          font-style: normal;
          font-weight: bold;
          animation:csyRotate2 3s linear  infinite;
        }
        i.hb:nth-child(1) {  top:-320px }

        i.hb:nth-child(2) {right:-300px; top:-110px }

        i.hb:nth-child(3) {right:-200px; top:230px }

        i.hb:nth-child(4) {left:-200px; top:230px }

        i.hb:nth-child(5) {left:-300px; top:-110px }

      }
  }
}
.refused-dialog {
  /deep/.nd-dialog-content {
    width: 620px;
    height: 400px;
    background: linear-gradient(180deg, #fdf0b8 0%, #ffffff 100%);
    border-radius: 30px;
    .default-content {
      background: none;
    }
    h4 {
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #DC5B2C;
      text-align: center;
      font-size: 32px;
      padding-top: 40px;
    }
    p {
      font-size:28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      padding: 30px 0;
      text-align: center;
      margin-top: 10px;
    }
    .btn {
      width: 440px;
      height: 80px;
      line-height: 80px;
      margin: auto;
    }
  }
}
.credit-dialog {
  /deep/.nd-dialog-content {
    width: 620px;
    height: 400px;
    background: linear-gradient(180deg, #fdf0b8 0%, #ffffff 100%);
    border-radius: 30px;
    .default-content {
      background: none;
    }

    .qq {
      width: 296px;
      height: 240px;
      background: url(./images/img_1.png) no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: -120px;
      left: 50%;
      transform: translateX(-50%);
    }
    p {
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      padding: 60px 0;
      text-align: center;
      margin-top: 50px;
    }
    .btn {
      width: 440px;
      height: 80px;
      margin: auto;
      line-height: 80px;
    }
  }
}
</style>
